







import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  name: 'EmptyState',
  props: {
    imgSrc: {
      type: String,
      default: '/assets/img/_Moon.png',
    },
    message: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const emptyMessage = computed(
      () => props.message || t('no-results-found-we-even-tried-looking-in-space').toString()
    );

    return { emptyMessage };
  },
});
